let user = {};

/**
 * sets user.
 * @param {Object} data Current user.
 */
export function setUser(data) {
  user = data;
}

/**
 * Gets user.
 * @returns {Object} User.
 */
export function getUser() {
  return user;
}
